import { DEV_CONFIG } from './properties/dev.properties';
import { PROD_CONFIG } from './properties/prod.properties';

const environmentConfig: { [key: string]: typeof PROD_CONFIG } = {
    production: PROD_CONFIG,
    development: DEV_CONFIG,
};

export const getConfig = () => {
    const profile = process.env.APPLICATION_PROFILE ?? 'production';
    return environmentConfig[profile] || PROD_CONFIG;
};

export const isProd = process.env.APPLICATION_PROFILE === 'production';
